import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import api from '../lib/api'

const SEVERITY_BG = {
  error: 'rgba(239,68,68,.04)',
  warn:  'transparent',
  info:  'transparent',
}

export default function Alertas() {
  const navigate = useNavigate()
  const [data,    setData]    = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get('/alertas')
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false))
  }, [])

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Alertas</strong> — Notificaciones del sistema</div>
        <div className="topbar-actions">
          <button className="btn btn-secondary btn-sm" onClick={() => { setLoading(true); api.get('/alertas').then(({ data }) => setData(data)).finally(() => setLoading(false)) }}>
            ↺ Actualizar
          </button>
        </div>
      </div>

      <div className="content">
        {loading && <div style={{ color: 'var(--muted)' }}>Cargando alertas…</div>}

        {!loading && data?.count === 0 && (
          <div className="panel">
            <div className="panel-body" style={{ textAlign: 'center', padding: '40px', color: 'var(--muted)' }}>
              ✅ Sin alertas activas — todo está funcionando correctamente
            </div>
          </div>
        )}

        {!loading && data?.count > 0 && (
          <div className="panel">
            <div className="panel-body" style={{ padding: 0 }}>
              {data.alertas.map((alerta, i) => (
                <div
                  key={i}
                  className="alert-item"
                  style={{ background: SEVERITY_BG[alerta.severity] }}
                >
                  <div className={`db-dot ${alerta.severity === 'error' ? 'err' : alerta.severity === 'warn' ? 'warn' : 'ok'}`} style={{ marginTop: '4px' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '13px' }}>{alerta.message}</div>
                    <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '2px' }}>
                      {alerta.tenant_name}
                      {alerta.ambiente && ` · Ambiente ${alerta.ambiente === '01' ? 'producción' : 'pruebas'}`}
                    </div>

                    <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                      {alerta.type === 'db_error' && (
                        <button className="btn btn-danger btn-sm" onClick={() => navigate('/db-health')}>Ver BDs</button>
                      )}
                      {(alerta.type === 'token_vencido' || alerta.type === 'token_por_vencer') && (
                        <button className="btn btn-primary btn-sm" onClick={() => navigate(`/empresas/${alerta.tenant_id}`)}>Ver tenant</button>
                      )}
                      {alerta.type === 'anulaciones_pendientes' && (
                        <button className="btn btn-secondary btn-sm" onClick={() => navigate('/anulaciones')}>Ver anulaciones</button>
                      )}
                    </div>

                    <div style={{ fontSize: '10px', color: 'var(--muted)', marginTop: '8px' }}>
                      {new Date(alerta.created_at).toLocaleString('es-SV')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
